import React, { useEffect, useCallback } from 'react';
import { getDirectusClient } from '../lib/directus';
import { useNavigate } from 'react-router-dom';
import { readMe, readPermissions } from '@directus/sdk';
import { useDispatch } from 'react-redux';
import { userdataAdd } from '../features/authdata/authdataSlice';
import { permisosadd } from '../features/permisos/permisosSlice';

function Validorligin(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Solo traemos los datos básicos necesarios del usuario
  const validarlogin = useCallback(async () => {
    const directus = await getDirectusClient();
    await directus
      .request(
        readMe({
          fields: [
            'id',
            'first_name',
            'last_name',
            'email',
            'bodega.id',
            'role.id',
            'role.name',
          ],
        })
      )
      .then(res => {
        
        dispatch(userdataAdd(res));
        validadarPermisos();
      })
      .catch(err => {
        navigate('/login');
        console.error(err);
      });
  }, [dispatch, navigate]);

  const validadarPermisos = useCallback(async () => {
    const directus = await getDirectusClient();
    await directus
      .request(readPermissions({ fields: ['*'] }))
      .then(permissionsRes => {
        dispatch(permisosadd(permissionsRes));
      })
      .catch(err => {
        console.error(err);
      });
  }, [dispatch]);

  useEffect(() => {
    validarlogin();
  }, [validarlogin]);

  return <div></div>;
}

export default Validorligin;
